// GENERATED by `pnpm ndrc gen` — do not edit by hand.
import { manifest as appel } from '@ndrc-apps/appel/manifest';
import { manifest as crm } from '@ndrc-apps/crm/manifest';
import { manifest as inbox } from '@ndrc-apps/inbox/manifest';
import { manifest as mini_sites } from '@ndrc-apps/mini_sites/manifest';
import { manifest as parcours } from '@ndrc-apps/parcours/manifest';
import { manifest as tableur } from '@ndrc-apps/tableur/manifest';
export const MANIFESTS = { appel, crm, inbox, mini_sites, parcours, tableur } as const;
export type AppId = keyof typeof MANIFESTS;
